import React from 'react';
import { Query } from 'react-apollo';
import { translate } from 'react-i18next';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import getPressReleases from '../../src/apollo/graphql/press/getPressReleases';
import { Column, Container, Row } from '../../src/components/Grid';
import { PressRelease, Section } from '../../src/components/Layout';
import { H3 } from '../../src/components/Title';
import Text from '../../src/components/Typography/Text';
import { media } from '../../src/styles/media';
import theme from '../../src/theme';
import createContext from '../../src/utils/format/createContext';
import formatDate from '../../src/utils/format/date';

const MediaWrapper = styled.div`
  margin: ${props => props.theme.layout.gutter * 2.75}px
    ${props => props.theme.layout.gutter * -0.75}px 0;

  ${media.desktop`
    margin: ${props => props.theme.layout.gutter * 5}px ${props =>
    props.theme.layout.gutter * 1.25}px ${props =>
    props.theme.layout.gutter * 3.5}px;
  `};
`;

const Span = styled.span``;

class Release extends React.PureComponent {
  render() {
    const { t, i18n } = this.props;
    return (
      <Query query={getPressReleases} context={createContext(i18n.language)}>
        {({ loading, error, data }) => {
          if (!loading && !error && data && data.getPressReleases) {
            const { getPressReleases } = data;
            const releases = getPressReleases;
            return (
              releases.length > 0 && (
                <Section>
                  <Container>
                    <Fade up>
                      <Text
                        variant="heading2"
                        color={theme.color.brand.primary}
                        as="h3"
                        marginBottom="30px"
                      >
                        {t('common:press.releases')}
                      </Text>
                    </Fade>
                    <Fade up>
                      <Row space={10}>
                        {releases.map(release => (
                          <Column
                            key={release.id}
                            mobile={1}
                            tablet={2}
                            desktop={2}
                            space={10}
                          >
                            <PressRelease
                              date={formatDate(
                                release.release_date,
                                'DD MMMM YYYY'
                              )}
                              img={release.visual_desktop}
                              title={release.detail.title}
                              link={release.detail.cta_url}
                              linkLabel={release.detail.cta_label}
                            >
                              {release.detail.description}
                            </PressRelease>
                          </Column>
                        ))}
                      </Row>
                    </Fade>
                  </Container>
                </Section>
              )
            );
          }

          return null;
        }}
      </Query>
    );
  }
}

export default translate()(Release);
